import React, { memo, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { createStructuredSelector } from "reselect";
import {
  setData,
  validatePortInNumber,
  resetPortInNumberValidation,
  uploadScreenshot,
  changeFormField
} from "ducks/actions";
import {
  makeSelectTelcoList,
  makeSelectPageValidations,
  makeSelectPortInForm,
  makeSelectPortInNumberValidation,
  makeSelectReferralCode,
  makeSelectPlanDetails,
  makeSelectActivationOrderRef
} from "ducks/selectors";
import SmartRender from "containers/SmartRender";
import { forms } from "utils/constants";
import validate, { asyncValidate } from "validations";
import get from "lodash/get";
import isFunction from "lodash/isFunction";

const PortInNumberHOC = Component =>
  function Comp(props) {
    const { setSelectedNumberTypePortIn } = props;
    useEffect(() => {
      if (isFunction(setSelectedNumberTypePortIn)) {
        setSelectedNumberTypePortIn();
      }
      // eslint-disable-next-line
    }, []);
    return <Component {...props} />;
  };

const mapStateToProps = createStructuredSelector({
  formValidations: makeSelectPageValidations(forms.PORT_IN_FORM),
  formValues: makeSelectPortInForm(),
  telcoList: makeSelectTelcoList(),
  portInNumberValidation: makeSelectPortInNumberValidation(),
  referralCode: makeSelectReferralCode(),
  planDetails: makeSelectPlanDetails(),
  orderRef: makeSelectActivationOrderRef()
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  portInOnlyMode: get(stateProps, "referralCode.port_in_only"),
  messageData: {
    referralCode: get(stateProps, "referralCode.value"),
    telcoName: get(stateProps, "formValues.telco.label"),
    telcoType: get(stateProps, "formValues.telco.portInType")
  }
});

export const mapDispatchToProps = dispatch => {
  return {
    uploadScreenshot: payload => dispatch(uploadScreenshot(payload)),
    setSelectedNumberTypePortIn: () => {
      dispatch(
        setData({ key: "selectedNumberType", data: { isPortIn: true } })
      );
      dispatch(
        changeFormField({
          form: forms.PRE_CHECKOUT_FORM,
          field: "number_type",
          value: "port_in"
        })
      );
    },
    onSubmit: (navigate, payload) => {
      dispatch(
        setData({ key: "selectedNumberType", data: { isPortIn: true } })
      );
      navigate();
    },
    validatePortInNumber: (number, order_ref) => {
      dispatch(validatePortInNumber({ number, order_ref }));
    },
    resetPortInNumberValidation: () => {
      dispatch(resetPortInNumberValidation());
    }
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);
export default compose(
  withConnect,
  reduxForm({
    form: forms.PORT_IN_FORM,
    destroyOnUnmount: false,
    validate,
    asyncValidate
  }),
  memo
)(PortInNumberHOC(SmartRender));
